import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { HeaderActions } from "../../../common/ui/layout/header/HeaderActions";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { ordersRoutes } from "../../OrdersRoutes";
import { CompleteRejectedOrderButton } from "../complete-rejected/buttons/CompleteRejectedOrderButton";
import { RejectOrderButton } from "../reject/buttons/RejectOrderButton";
import { ApproveOrderDeliveryButton } from "./approve-delivery/ApproveOrderDeliveryButton";
import { OrderOverriddenInfo } from "./OrderOverriddenInfo";

export const OrderDashboardHeader: React.VFC = () => {
    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={ordersRoutes} />
                <HeaderActions>
                    <RejectOrderButton />
                    <CompleteRejectedOrderButton />
                    <ApproveOrderDeliveryButton />
                </HeaderActions>
            </PageHeader>
            <OrderOverriddenInfo />
        </>
    );
};
